<template>
  <div class="main">
    <div class="subject">
      <a-table :columns="columns" :dataSource="lists" :pagination="pagination" :rowKey="record => record.id"
        :loading="loading" @change="handleTableChange" bordered>
        <template slot="title">
          <a-button @click="handle('add', {})">添加映射</a-button>
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a @click="handle('edit', record)">编辑</a>
          <a-popconfirm title="确定要删除么？" okText="确定" cancelText="取消" @confirm="del(record, index)">
            <a class="active">删除</a>
          </a-popconfirm>
        </template>
      </a-table>

      <a-modal v-model="visible" :title="title" @ok="modifyExpert" :maskClosable="false" destroyOnClose
        :confirmLoading="confirmLoading" @cancel="handleCancel">
        <a-form :form="form" @submit="modifyExpert">
          <div style="width:450px;display:inline-block">
            <a-form-item style="display:none">
              <a-input v-decorator="['id']"></a-input>
            </a-form-item>
            <a-form-item label="原栏目：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }" :max-length="10">
              <a-select showSearch :filterOption="cateFilter" v-decorator="[
                'catid',
                {
                  rules: [
                    {
                      required: true,
                      message: '原栏目必填'
                    }
                  ],
                  initialValue: ''
                }
              ]">
                <template v-for="(item, id) in fabulist">
                  <a-select-option :key="id" :value="item.id">{{ item.name + '(' + item.id + ')' }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
            <a-form-item label="推送栏目id：" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
              <a-select showSearch :filterOption="cateFilter" v-decorator="[
                'push_id',
                {
                  rules: [
                    {
                      required: true,
                      message: '推送栏目必填'
                    }
                  ],
                  initialValue: ''
                }
              ]">
                <template v-for="(item, catid) in cateList">
                  <a-select-option :key="catid" :value="item.catid">{{ item.catname + '(' + item.catid + ')' }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </a-form>
      </a-modal>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id'
  },
  {
    title: '原栏目id',
    dataIndex: 'catid',
    align: 'center',
    scopedSlots: { customRender: 'catid' }
  },
  {
    title: '原栏目名称',
    dataIndex: 'catname',
    scopedSlots: { customRender: 'catname' }
  },
  {
    title: '推送栏目id',
    dataIndex: 'push_id',
    scopedSlots: { customRender: 'push_id' },
    align: 'center'
  },
  {
    title: '推送栏目名称',
    dataIndex: 'push_name',
    scopedSlots: { customRender: 'push_name' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 200,
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
];
export default {
  data() {
    return {
      columns,
      lists: [],
      pagination: {
        pageSize: 20
      },
      loading: false,
      param: {
        page: 1
      },
      form: this.$form.createForm(this, { name: 'modify' }),
      visible: false,
      title: '添加映射',
      confirmLoading: false,
      fabulist: [],
      cateList: []
    };
  },
  methods: {
    getList() {
      this.loading = true;
      this.$http
        .post('http://fabuhao-sync.ycrmt.cn/api/map/list', this.param)
        .then(res => {
          if (res.data.state === 0) {
            const pagination = { ...this.pagination };
            this.lists = res.data.data.lists;
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          }
          this.loading = false;
        });
    },
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { limit: 9999 })
        .then(res => {
          if (res.data.state == 200) {
            this.cateList = res.data.data;
          }
        });
    },
    getFaBulist() {
      this.$http.post('https://fabuhao-sync.ycrmt.cn/api/map/fabulist').then(res => {
        if (res.data.state === 0) {
          this.fabulist = res.data.data;
        }
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.getList();
    },
    handle(type, record) {
      let that = this;
      that.visible = true;
      if (type == 'edit') {
        that.title = '编辑映射';
        that.$nextTick(() => {
          that.imageUrl = record.adimg;
          that.form.setFieldsValue({
            id: record.id ? record.id : '',
            catid: record.catid,
            // catname: record.catname,
            push_id: record.push_id.toString()
            // push_name: record.push_name
          });
        });
      } else {
        that.title = '添加映射';
        that.form.resetFields();
      }
    },
    del(record) {
      this.$http
        .post('http://fabuhao-sync.ycrmt.cn/api/map/remove', { id: record.id })
        .then(res => {
          if (res.data.state === 0) {
            this.$message.success('删除成功');
            this.param.page = 1;
            this.getList();
          }
        });
    },
    handleCancel() {
      this.visible = false;
    },
    modifyExpert(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let data = { ...values };
          this.fabulist.forEach(item => {
            if (data.catid == item.id) {
              data.catname = item.name;
            }
          });
          this.cateList.forEach(item => {
            if (data.push_id == item.catid) {
              data.push_name = item.catname;
            }
          });
          this.confirmLoading = true;
          this.$http
            .post('http://fabuhao-sync.ycrmt.cn/api/map/update', data)
            .then(res => {
              this.confirmLoading = false;
              if (res.data.state == 0) {
                this.$message.success('添加成功');
                this.visible = false;
                this.getList();
              }
            });
        }
      });
    },
    cateFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  },
  created() { },
  mounted() {
    this.getList();
    this.getFaBulist();
    this.getCateList();
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
}

.subject {
  padding: 10px;
}

.active {
  color: #f00;
  margin-left: 5px;
}
</style>
